<ng-container *ngIf="translations$ | async as translations">
  <h3 class="mt-3">{{ translations['Documents'] }}</h3>
  <div class="row col-12" *ngIf="files.length; else noFiles">
    <table>
      <thead>
        <tr>
          <td>
            <i>{{ translations['IsPublic'] }}</i>
          </td>
          <td>
            <i>{{ translations['Filename'] }}</i>
          </td>
          <td>
            <i>{{ translations['Filetitle'] }}</i>
          </td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let file of files">
          <ng-container *ngIf="isEdit">
            <td class="public-checkbox">
              <input
                type="checkbox"
                (change)="toggleFileMode(file.Id, file.RefId, $event)"
                [checked]="file.IsPublic"
              />
            </td>
            <td class="filename">
              <a [href]="file.Url" target="_blank">{{ file.Filename }}</a>
            </td>
            <td class="title">
              <hazmatsuite-next-inline-edit-label
                [label]="file.Title"
                (save)="saveFilename($event, file.Id, file.RefId)"
              ></hazmatsuite-next-inline-edit-label>
            </td>
            <td class="delete-btn">
              <i
                class="ifc-custom ifc-bin pointer"
                aria-hidden="true"
                (click)="delete(file.Id, file.RefId)"
              ></i>
            </td>
          </ng-container>
          <td *ngIf="!isEdit" colspan="4">
            <a [href]="file.Url" target="_blank">{{ file.Filename }}</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row col-12 mt-3" *ngIf="isEdit">
    <hazmatsuite-next-file-upload
      (uploadFiles)="upload($event)"
    ></hazmatsuite-next-file-upload>
  </div>
  <ng-template #noFiles>
    <span class="row col-12">{{ translations['NoDocumentsAttached'] }}</span>
  </ng-template>
</ng-container>
